/**
 * Class indicating the existence of a default value for a field, and its "protected" status
 */
export class DefaultValue<T> {

  /**
   * Default value of the field
   */
  public value: T | null = null;
  /**
   * Is the value protected or not
   */
  public isLocked: boolean = false;

  public constructor(value: T | null, isLocked?: any) {
    this.value = value;
    if (isLocked) {
      this.isLocked = true;
    }
  }

  /**
   * Builder-syntax function to protect the field.
   * @param lock is the field protected or not
   */
  public withLock(lock?: boolean): DefaultValue<T> {
    this.isLocked = lock !== false;
    return this;
  }
}
